import React from 'react';
import { Redirect, Route } from 'react-router';

// eslint-disable-next-line react/prop-types
function PrivateRoute({ component: Component, isAuthenticated, ...rest }) {
	return <Route {...rest} render={props => (isAuthenticated ? <Component {...props} /> : <Redirect to="/" />)} />;
}

export default PrivateRoute;
